import { gql } from "@apollo/client"

const GET_INVITATIONS_MATRIX = gql`  
  query invitationsMatrix(
    $page: Int!, 
    $perPage: Int!, 
    $orderBy: [QueryInvitationsMatrixOrderByOrderByClause!]  
    $input: InvitationsMatrixInput!
    $where: QueryInvitationsMatrixWhereWhereConditions
  ) {
	  invitationsMatrix(first: $perPage, page: $page, input: $input, orderBy: $orderBy, where: $where) {
		  data {
			  id
        invitation_id
        student_id
        user_id
        student
        guardian
        email
        status
        user_mobile
        guardian_telephone
        last_email_errored
  		  last_email_queued
  		  last_email_sent
        last_active_at
			  activated_at
        activation_code
        meeting_type
        last_sent_at
        contact_sequence
        legal_guardian
			  total_available_guardians
			  total_selected_guardians
      }
      
      paginatorInfo {
        total
        currentPage
        hasMorePages
        lastPage
        perPage
      }
	  }
  } 
`

export { GET_INVITATIONS_MATRIX }